export const initialFilterState = () => ({
  searchKey: "",
  page: 1,
  perPage: 10,
  fuelCategory: "",
  productCode: "",
});
